// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/layers/search_platform_layer
export var STATSIG_DEFAULT_LAYER = 'search_platform_layer';
export var DEFAULT_STATSIG_EXPERIMENT_CONFIG = {
  experimentId: '',
  shadowExperimentId: '',
  controlId: '',
  abTestId: ''
};